import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Parametro, Cliente } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParametroService {

  url = environment.url + '/parametros';

  constructor(private http: HttpClient) {}

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/count?cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }&cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  getByID(parametro: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/id?cliente=${ localStorage.getItem('idCliente') }&parametro=${ parametro }`, { headers }).pipe( map( data => data));
  }

  add(parametro: Parametro) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    parametro.cliente = cliente;
    let body = JSON.stringify(parametro);

    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.post(`${ this.url }/add?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  update(parametro: Parametro) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    parametro.cliente = cliente;
    let body = JSON.stringify(parametro);

    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.put(`${ this.url }/update?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  delete(parametro: Parametro) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    parametro.cliente = cliente;

    return this.http.delete(`${ this.url }/delete/?cliente=${ parametro.cliente.id }&parametro=${ parametro.nombre }&usuario=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }

  getByParametro(value: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/id?cliente=${ localStorage.getItem('idCliente') }&parametro=${ value }`, { headers }).pipe( map( data => data));
  }

  getLicencia() {
    let parametro = 'LICENCIA';
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/licencia?cliente=${ localStorage.getItem('idCliente') }&parametro=${ parametro }`, { headers }).pipe( map( data => data));
  }

}
